import { Feather, MaterialIcons } from "@expo/vector-icons";
import React from "react";
import { useCallback } from "react";
import { Linking } from "react-native";
import { useFlashMessages } from "@towersystems/roam-common-native";
import { PageItemType } from "../../../../../../utilities/layout";
import { useTheme } from "@towersystems/roam-common-native";
import { QuickKey as BaseQuickKey } from "../../../QuickKey";

const LABEL_PREAMBLE = "Custom URL";

export interface LinkQuickKeyProps {
  item: PageItemType;
}

export const LinkQuickKey = React.forwardRef<any, LinkQuickKeyProps>(
  ({ item }, ref) => {
    const { showMessage } = useFlashMessages();

    const { colors: Colors } = useTheme();

    const backgroundColor = Colors.action;

    const url = item.config?.link?.url;

    const defaultTitle = url ? `${LABEL_PREAMBLE} ${url}` : LABEL_PREAMBLE;
    const title = item.config?.label || defaultTitle;

    const isNewTab = !!item.config?.link?.newTab;

    const onPress = useCallback(
      async (url: string) => {
        // Checking if the link is supported for links with custom URL scheme.
        const supported = await Linking.canOpenURL(url);

        if (supported) {
          // Opening the link with some app, if the URL scheme is "http" the web link should be opened
          // by some browser in the mobile
          await Linking.openURL(url);
        } else {
          showMessage({
            message: `Don't know how to open this URL: ${url}`,
            severity: "error",
          });
        }
      },
      [url]
    );

    return (
      <BaseQuickKey
        {...{ backgroundColor }}
        ref={ref as any}
        onPress={onPress}
        iconPrimary={<Feather name="external-link" size={24} color="white" />}
        iconSecondary={
          isNewTab ? <MaterialIcons name="tab" size={24} color="white" /> : null
        }
        label={title}
      />
    );
  }
);
